import React from "react";
import { Link } from "react-router-dom";

export default function EduPagination({
  pageNumber,
  setPageNumber,
  pageLimit,
  setPageLimit,
  totalCount,
  isTotalPages = null, // New optional prop: explicitly tells if pageLimit is total pages
  pageSize = null, // New optional prop: actual items per page from API
}) {
  // Determine if pageLimit is total pages or items per page
  // If isTotalPages is explicitly provided, use it; otherwise use heuristic
  let isTotalPagesValue;
  if (isTotalPages !== null) {
    // Explicitly provided
    isTotalPagesValue = isTotalPages;
  } else {
    // Use heuristic for backward compatibility
    const calculatedItemsPerPage =
      totalCount > 0 && pageLimit > 0 ? totalCount / pageLimit : 0;
    isTotalPagesValue =
      calculatedItemsPerPage >= 5 &&
      calculatedItemsPerPage <= 50 &&
      pageLimit > 10;
  }

  const totalPages = isTotalPagesValue
    ? pageLimit
    : pageLimit > 0
    ? Math.ceil(totalCount / pageLimit)
    : 1;

  // Use pageSize from API if provided, otherwise calculate
  const itemsPerPage = isTotalPagesValue
    ? pageSize !== null
      ? pageSize
      : totalPages > 0
      ? Math.ceil(totalCount / totalPages)
      : pageLimit
    : pageLimit > 0
    ? pageLimit
    : 10;

  const startEntry =
    totalCount > 0 && totalPages > 0 ? (pageNumber - 1) * itemsPerPage + 1 : 0;
  const endEntry =
    totalCount > 0 && totalPages > 0
      ? Math.min(pageNumber * itemsPerPage, totalCount)
      : 0;

  // Determine which page numbers to show
  let pageButtons = [];
  if (totalPages <= 2) {
    for (let i = 1; i <= totalPages; i++) {
      pageButtons.push(i);
    }
  } else {
    if (pageNumber === 1) {
      pageButtons = [1, 2];
    } else if (pageNumber === totalPages) {
      pageButtons = [totalPages - 1, totalPages];
    } else {
      pageButtons = [pageNumber, pageNumber + 1];
    }
  }

  return (
    <>
      <div className="row justify-content-between">
        <div className="col-lg-6">
          <p>
            Showing {startEntry} to {endEntry} of {totalCount} entries
          </p>
        </div>
        <div className="col-lg-6">
          <div className="custom-pagination">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                {pageNumber > 1 && (
                  <li
                    className="page-item"
                    onClick={() => setPageNumber(pageNumber - 1)}
                  >
                    <Link className="page-link" to="#">
                      Previous
                    </Link>
                  </li>
                )}
                {pageButtons.map((num) => (
                  <li
                    key={num}
                    className={`page-item${
                      num === pageNumber ? " active" : ""
                    }`}
                    onClick={() => setPageNumber(num)}
                  >
                    <Link className="page-link" to="#">
                      {num}
                    </Link>
                  </li>
                ))}
                {pageNumber < totalPages && (
                  <li
                    className="page-item"
                    onClick={() => setPageNumber(pageNumber + 1)}
                  >
                    <Link className="page-link" to="#">
                      Next
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
